import { types } from "../action-types";

const initialState = {
  loading: false,
  forFollowLoading: false,
  resumedetails: [],
  error: false,
};

const getResume3dReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_RESUME3D_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_RESUME3D_SUCCESS:
      return {
        ...state,
        loading: false,
        forFollowLoading: false,
        resumedetails: action.payload,
        error: false,
      };
    case types.GET_RESUME3D_FAILURE:
      return {
        ...state,
        loading: false,
        resumedetails: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getResume3dReducer;
